var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{on:{"click":function($event){return _vm.$router.replace({name:'homepage'})}}},[_vm._v(" mdi-home ")]),_vm._v(" Neplatný token ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }